<template lang="pug">
include /mixins

div.tt-space_mt--3.--5-md
  +b.g-row--align_center.--appearance_column
    +b.g-cell.g-cols--12.tt-space_mb--8.--10-md
      +b.ds-caption.--size_3md.--size_lg-md.--semibold.--appearance_center.P {{ _('Введіть код з SMS, відправлений на') }}
      +b.ds-caption.--size_3md.--size_lg-md.--semibold.--appearance_center.P {{ phone }}
    +b.g-cell.g-cols--12
      +b.g-row--align_center.--justify_center
        +b.g-cell.g-cols
          +b.tt-link--size_md.--text-8.ds-caption--size_md.--semibold.--appearance_center(
            @click.prevent='$emit("change-phone")'
          )
            +e.title.SPAN {{ _('Змінити номер телефона') }}
    +b.relative.tt-space_mt--7.--10-md.tt-space_mb--7.--10-md
      validation-provider(
        :rules="'required|length:6'"
        v-slot="{ errors }"
        name='code'
      )
        otp-input(ref='otp' :value='code' :length='6' :is-load='isLoad' @input='$emit("update:code", $event)')
        +b.error-label--top.LABEL(v-if="errors.length && !errorCode") {{ errors[0] }}
        +b.error-label--top.LABEL(v-if="errorCode") {{ errorCode }}
    +b.g-cell.g-cols--12
      +b.g-row--justify_center
        resend-timer(:time='60000' :key='resendKey')
          template(#default='{ minutes, seconds }')
            +b.g-cell.g-cols
              +b.ds-caption--size_md.--color_text-8.--semibold.P(
                v-if='minutes || seconds'
              ) {{ _('Надіслати повторно:') }} #[span(class='timer-text ds-caption ds-caption--color_text-1') {{ minutes|dateTime }}:{{ seconds|dateTime }} ]
              +b.tt-link--variant_start.--styling_default.ds-caption--size_xs.--size_sm-xl.--appearance_center.A(
                @click.prevent='onResend'
                v-else
              )
                +e.text.P {{ _('Отправить пароль заново') }}
</template>

<script>
import ResendTimer from '@app/Order/ResendTimer'

export default {
  name: 'StepOtp',
  components: { ResendTimer },
  props: {
    phone: { type: String, default: '' },
    code: { type: String, default: '' },
    isLoad: { type: Boolean, default: false },
    errorCode: { type: String, default: '' },
  },
  data() {
    return {
      resendKey: 0,
    }
  },
  methods: {
    clearPin() {
      if (this.$refs.otp) this.$refs.otp.clearPin()
    },
    onResend() {
      this.resendKey++
      this.$emit('resend')
    },
  },
}
</script>
